import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AgreementType from 'bundles/apex/deals/show/overview/values/agreement_type';
import AutoCalculatedFields from 'bundles/apex/deals/show/overview/values/auto_calculated_fields';
import Card from 'bundles/apex/card/details';
import CommissionAmount from 'bundles/apex/deals/show/overview/values/commission_amount';
import CommissionPercent from 'bundles/apex/deals/show/overview/values/commission_percent';
import Currency from 'bundles/apex/deals/show/overview/values/currency';
import CustomFields from 'bundles/apex/deals/show/overview/values/custom_fields';
import LeaseRate from 'bundles/apex/deals/show/overview/values/lease_rate';
import LeaseTerm from 'bundles/apex/deals/show/overview/values/lease_term';
import Percent from 'bundles/apex/deals/show/overview/values/percent';
import Text from 'bundles/apex/deals/show/overview/values/text';

export function FinancialsCard({ deal }) {
  return (
    <Card label="Transaction">
      <Text label="Deal ID" name="identifier"/>
      <Text label="Deal Title" name="name" />
      <AgreementType />
      <Text name="leaseType" value={deal.leaseTypeLabel} />
      <LeaseRate/>
      <LeaseTerm/>
      <Currency name="transactionValue" />
      <AutoCalculatedFields/>
      <CommissionPercent/>
      <CommissionAmount/>
      <Percent name="capRate" />
      <Currency name="netOperatingIncome" />
      <Percent name="closeProbability" />
      <Text name="deadReason" />
      <CustomFields category="financials" />
    </Card>
  );
}

FinancialsCard.propTypes = {
  deal: PropTypes.shape({
    leaseTypeLabel: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(FinancialsCard);
